export default __webpack_public_path__ + "static/media/rightArrow.46aea7d2.svg";